<template>
  <div class="main-box">
    <van-nav-bar
        title="住院号列表"
        left-arrow
         left-text="返回"
        @click-left="onClickLeft"
      />
    <div class="cell" v-if="showflag">
      <div
        class="item"
        size="large"
        v-for="(item, index) in hospitalizationList"
        :key="index"
        @click="goCarddetails(item)"
      >
        <div class="cell_item">
          <div class="title">{{item.Name}}</div>
          <div class="value">住院号: {{item.InPatientId}}</div>
          
        </div>
        <div class="cell_item">
          <div class="value">入院时间:{{item.InDate}}</div>
          <div class="value">科室: {{item.DepartmentName}}</div>
          <!-- class="btn_mini_style" -->
          <!-- <div>
            <van-button
              color="#5B8DF6"
              size="small"
              class="btn_mini_style"
              round
              @click.stop="query(item.medCardNo)"
              >查看</van-button
            >
          </div> -->
        </div>
      </div>
    </div>
    <van-empty
      v-else
      image="https://account.kmmds.top/datainfo_pic/error.png"
      description="该就诊人没有住院记录"
    />
    
  </div>
</template>

<script>
import setOptions from "@/mixins/setOption";
import Nav from "@/components/nav.vue";
import backindex from '@/mixins/backindex'
import { Dialog } from "vant";
export default {
  mixins: [setOptions,backindex],
  data() {
    return {
      navTitle: "就诊卡列表",
      hospitalizationList: [],
      isLoad: true,
      medCardNo: "",
      CardNo:"",
      showflag:false
    };
  },
  components: {
    Nav
  },
  mounted(){
     if (this.$route.query) {
      //  console.log(this.$route.query);
      this.clientId = this.$route.query.clientId;
      this.name = this.$route.query.name;
      this.CardNo=this.$route.query.item
    }
    console.log(this.CardNo)
    if (!this.CardNo || this.CardNo == "") {
      this.$router.push('/patient_card_selectuser')
      return;
    }
     this.gethospitalization()
  },

  methods: {
    onClickLeft(){
       this.$router.push('/index')
    },
    //
    //跳转详情页
    goCarddetails(item) {
        // console.log(item)
         this.$router.push({
        path: "/hospitalization_detail_D_a",
        query: {
          InPatientId: item.InPatientId,
          EndDate: new Date().getFullYear() + "-" + (new Date().getMonth() + 1) + "-" + new Date().getDate() +" 23:59:59",
          BeginDate: item.InDate,
        },
      });
    },
   
    async gethospitalization() {
      // console.log(this.CardNo)
      try {
        this.$showLoad();
        let url = "/outpatientfee/QueryInPatientIdById";
        let data = {
          // clientId:"00004462"
          CardNo:this.CardNo.IDCardNo
        };
        await this.$axios_request.axios_request_body(
          "nodeserver",
          url,
          "POST",
          data,
          (resultdata) => {
            this.$hideLoad();
            // console.log(resultdata)
            // if(resultdata&&resultdata.data){
              this.hospitalizationList = resultdata.data.data;
              if(this.hospitalizationList[0].ErrorMsg &&this.hospitalizationList[0].ErrorMsg=="请求条件有误或该条件下没有数据返回" )
              {
               this.showflag=false
              }else{
                this.showflag=true
              }
            // }
         
          }
        );
      } catch (error) {
        console.log(error);
        this.$hideLoad();
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.main-box {
  width: 100vw;
  height: 100vh;
  background: white;

  .nav {
    margin-bottom: 8px;
  }
  .cell {
    display: flex;
    flex-direction: column;
    width: 93%;
    margin: 0px auto;
    .cell_item {
      display: flex;
      flex-direction: row;
      line-height: 40px;
      justify-content: space-between;
      margin-left: 10px;
      margin-right: 10px;
      .title {
        font-size: 18px;
        color: #323233;
      }
      .value {
        font-size: 16px;
        color: #555;
      }
      .label {
        font-size: 15px;
        color: #999;
      }
    }
    // margin-top: 15px;
  }
  .item {
    display: flex;
    flex-direction: column;
    padding-top: 16px;
    padding-bottom: 16px;
    &::after {
      border-bottom: 0;
    }
    margin-bottom: 15px;
    background-color: #f7f8fa;
    box-shadow: 0 8px 12px #ebedf0;
    border-radius: 8px;
  }

  .btn-box {
    .btn {
      margin-left: 40px;
    }
  }
}
.cell_box {
  display: flex;
  flex-direction: column;
}
.mar {
  margin-top: 10px;
}
.submit {
  margin: 55px 20px 25px 20px;
}
.Btn_style {
  width: 100%;
  // margin: 0px auto;
  position: fixed;
  bottom: 0vh;
  display: flex;
  flex-direction: column;
  justify-self: center;
  align-items: center;
  height: 70px;
  background-color: #ffffff;
  border-top: 1px solid #aaaaaa;
  .btn {
    width: 95%;
    letter-spacing: 10px;
    font-size: 16px;
    margin: 10px auto;
    background-color:#5B8DF6;
  }
}
.btn_mini_style {
  width: 80px;
  height: 25px;
  letter-spacing: 7px;
}
 .van-button--round {
  border-radius: 10px;
}
</style>